var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.37,42.74c1.53-1.37,3.92-1.16,5.37.29l20.05,20.05,32.55-32.55c1.28-1.28,3.32-1.58,4.83-.57,2.08,1.38,2.28,4.21.61,5.87l-32.56,32.56c-3,3-7.86,3-10.86,0l-20.14-20.14c-1.53-1.53-1.48-4.04.15-5.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeCheck);
export default __webpack_public_path__ + "static/media/acae_check.35bbf743.svg";
export { ForwardRef as ReactComponent };